/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerLiteP2pPayment} from '../api'

export const useMutationRegisterLiteP2pPayment = createReactQueryMutationHook('registerLiteP2pPayment', registerLiteP2pPayment)
